module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daniel L. Migliore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Daniel L. Migliore")]), _vm._v(" is Charles Hodge Professor Emeritus of Systematic Theology at Princeton Theological Seminary.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/naMkpf/tc-custom/9781467447072.jpg?1728727292194",
      "alt": "This image is the cover for the book Reading the Gospels with Karl Barth"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reading the Gospels with Karl Barth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Over the course of his multivolume "), _c('i', [_vm._v("Church Dogmatics")]), _vm._v(", Karl Barth not only cites thousands of Scripture texts but also offers extensive exegetical discussion of numerous passages. In this book twelve leading theologians and biblical scholars examine Barth's exegesis of particular passages in the Gospels."), _c('br'), _c('br'), _vm._v(" How does Barth's practice of theological exegesis play out in his reading of the Gospels? What are the fundamental features of Barth's interpretation of Gospel texts, and to what extent do they enliven theology, biblical studies, and ethics today? "), _c('i', [_vm._v("Reading the Gospels with Karl Barth")]), _vm._v(" explores answers to such questions and offers fresh stimulus for further study and discussion."), _c('br'), _c('br'), _c('b', [_vm._v("CONTRIBUTORS")]), _c('br'), _c('br'), _vm._v(" Richard Bauckham"), _c('br'), _vm._v(" Kendall Cox"), _c('br'), _vm._v(" Beverly Roberts Gaventa"), _c('br'), _vm._v(" Eric Gregory"), _c('br'), _vm._v(" Willie James Jennings"), _c('br'), _vm._v(" Paul Dafydd Jones"), _c('br'), _vm._v(" Bruce L. McCormack "), _c('br'), _vm._v(" Daniel L. Migliore"), _c('br'), _vm._v(" Jürgen Moltmann"), _c('br'), _vm._v(" Paul T. Nimmo"), _c('br'), _vm._v(" Fleming Rutledge"), _c('br'), _vm._v(" Shannon Nicole Smythe")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0